



































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import BlogStore, { BlogStoreInterface } from '@/resource/blog/blog.store';
import Divider from '@/components/common/Divider.vue';
import BlogDetail from '@/components/blogs/BlogDetail.vue';
import BlogBanner from '@/components/blogs/BlogBanner.vue';
import BlogDetailLoading from '@/components/blogs/BlogDetailLoading.vue';
import SignupBanner from '@/components/common/SignupBanner.vue';
import { getToken } from '@/utils/cookie';
import seoDefault from '@/utils/seo-default';
import TestBanner from '@/main-components/common/TestBanner.vue';
// import Adsense from '@/main-components/adsense/Adsense.vue';
// import AdsenseModal from '@/main-components/adsense/AdsenseModal.vue';

@Component({
  components: {
    Divider,
    BlogDetail,
    BlogBanner,
    BlogDetailLoading,
    SignupBanner,
    TestBanner,
    // Adsense,
    // AdsenseModal,
  },
  metaInfo(this: Blog): MetaInfo {
    return {
      title: `${this.blog ? this.blog.title : 'blog'} |`,
      meta: [
        ...seoDefault({
          title: `${this.blog ? this.blog.title : 'blog'} | Mysoalan`,
          description: this.blog
            ? this.blog.description
            : 'Terokai dan baca berita dan artikel terkini kami. Di sini anda boleh mendapatkan petua berkaitan pengajaran, cara menggunakan Mysoalan, atau apa sahaja yang berkaitan dengan pendidikan.',
          thumbnail: this.blog ? this.blog.thumbnail : '',
        }),
      ],
    };
  },
})
export default class Blog extends Vue {
  blogStore: BlogStoreInterface = BlogStore;

  isLoading = true;

  openAdsModal: any = null;

  openModalAds(openModal: any) {
    this.openAdsModal = openModal;
  }

  mounted() {
    this.openAdsModal && this.openAdsModal();
  }

  get isLoggedin() {
    return getToken() ? true : false;
  }

  get blogUuid() {
    const params = this.$route.params.uuid.split('-');
    return params[params.length - 1] ? params[params.length - 1] : 'not-avail';
  }

  get blog() {
    return this.blogStore.blog;
  }

  get blogContent() {
    let blogContent: string[] = [];
    if (this.blog) {
      //NOTE: Split by signup banner placement
      blogContent = this.blog.contentHtml.split('<h3>--signup--</h3>');
    }

    return blogContent;
  }

  get detail() {
    if (this.blog) {
      const date = this.$dayjs(this.blog.createdAt);
      return `${date.format('D MMM')}, ${this.blog.duration} minutes read`;
    } else {
      return '';
    }
  }

  async created() {
    await this.blogStore.fetchBlog(this.blogUuid);
    this.isLoading = false;

    if (this.blog) {
      this.$sendMpEvent({
        event: this.$mp_value.BlogView,
        properties: {
          uuid: this.blog.uuid ? this.blog.uuid : '',
          title: this.blog.title,
        },
      });
    }
  }
}
